import { Accordion as ArkAccordion } from '@ark-ui/react';

import { cn } from '../../lib/utils';

type AccordionRootProps = ArkAccordion.RootProps;
type AccordionItemProps = ArkAccordion.ItemProps;
type AccordionItemTriggerProps = ArkAccordion.ItemTriggerProps;
type AccordionItemContentProps = ArkAccordion.ItemContentProps;
type AccordionItemIndicatorProps = ArkAccordion.ItemIndicatorProps;

function AccordionRoot({ className, ...props }: AccordionRootProps) {
	return <ArkAccordion.Root className={cn('pt-accordion', className)} {...props} />;
}

function AccordionItem({ className, ...props }: AccordionItemProps) {
	return <ArkAccordion.Item className={cn('pt-accordion-item', className)} {...props} />;
}

function AccordionItemTrigger({ className, ...props }: AccordionItemTriggerProps) {
	return (
		<ArkAccordion.ItemTrigger className={cn('pt-accordion-item-trigger', className)} {...props} />
	);
}

function AccordionItemContent({ className, ...props }: AccordionItemContentProps) {
	return (
		<ArkAccordion.ItemContent className={cn('pt-accordion-item-content', className)} {...props} />
	);
}

function AccordionItemIndicator({ className, ...props }: AccordionItemIndicatorProps) {
	return (
		<ArkAccordion.ItemIndicator
			className={cn('pt-accordion-item-indicator', className)}
			{...props}
		/>
	);
}

const Accordion = Object.assign(AccordionRoot, {
	Root: AccordionRoot,
	Item: AccordionItem,
	ItemTrigger: AccordionItemTrigger,
	ItemContent: AccordionItemContent,
	ItemIndicator: AccordionItemIndicator,
	Context: ArkAccordion.Context,
	ItemContext: ArkAccordion.ItemContext
});

export {
	Accordion,
	type AccordionRootProps,
	type AccordionItemProps,
	type AccordionItemTriggerProps,
	type AccordionItemContentProps,
	type AccordionItemIndicatorProps
};
